const buildPagination = function(total_results, target_pagination_page) {

    // Pagination
    if( total_results > 10 )
    {
        $('.pagination li:not(.arrow)').remove();

        let i,
            itemsToShow = 10,
            targetPage = parseInt(target_pagination_page);
        for( i = 1; i <= ( total_results / 10 ); i++ ) {
            if((i > (targetPage - 5) && i < targetPage + itemsToShow) || i === 1) {
                $('.pagination .arrow:last').before( 
                    $('<li'+ ( ( i === target_pagination_page ) ? ' class="current"' : '' )
                    + '><a href="#" data-target-page="'+ i +'">'+ i +'</a></li>') 
                );
            }
        }
        if( total_results % 10 !== 0 ) {
            $('.pagination .arrow:last').before( $('<li'+ ( ( i === target_pagination_page ) ? ' class="current"' : '' ) +'><a href="#" data-target-page="'+ i +'">'+ i +'</a></li>') );
        }

        if( target_pagination_page === 1 ) {
            $('.pagination .arrow:first').addClass('unavailable');
        }
        else {
            $('.pagination .arrow:first').removeClass('unavailable');
        }

        if( ( total_results % 10 !== 0 && target_pagination_page === i ) || (  total_results % 10 === 0 && target_pagination_page === i-1 ) ) {
            $('.pagination .arrow:last').addClass('unavailable');
        }
        else {
            $('.pagination .arrow:last').removeClass('unavailable');
        }

        if(targetPage + itemsToShow < total_results / 10) {
            $('.pagination .arrow:last').siblings('li:last').before('<li><span>. . .</span></li>')
        }

        if(targetPage > 6) {
            $('.pagination .arrow:first').siblings('li:first').after('<li><span>. . .</span></li>')
        }

        $('.pagination .arrow:first').find('a').attr( 'data-target-page', parseInt( target_pagination_page, 10 ) -1 );
        $('.pagination .arrow:last a').attr( 'data-target-page', parseInt( target_pagination_page, 10 ) +1 );

        $('.pagination-container').show();
    }
    else {
        $('.pagination-container').hide();
    }
};